import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Dispositif } from '@features/referentiel/models/dispositif';
import { Response } from '@features/referentiel/models/response';
import { DispositifConfig } from '@features/referentiel/config/dispositif.config';


@Injectable({
  providedIn: 'root',
})
export class DispositifService {
  constructor(private http: HttpClient) {}

  getDispositifs(): Observable<Response<Dispositif>> {
    return this.http.get<Response<Dispositif>>(DispositifConfig.dispositifFormationsBySource);
  }
}
